import {Box} from '@mui/material';


export function Thumbnail({image}: any) {
    // console.log({image})
    return (
        <Box sx={{
            backgroundColor: "black",
            height: "84px",
            width: "153px",
            justifyContent: "center",
            display: "flex",
            borderRadius: "2px"
        }}>
            <Box
                component="img"
                src={URL.createObjectURL(image)}
                alt="Image Preview"
                sx={{height: '100%', width: "auto", borderRadius: "8px"}}
            />
        </Box>
    );
}

export function LargeThumbnail({image}: any) {
    // console.log({image})
    return (
        <Box sx={{
            backgroundColor: "black",
            height: "160px",
            width: "300px",
            justifyContent: "center",
            display: "flex",
            borderRadius: "2px"
        }}>
            <Box
                component="img"
                src={image}
                alt="Image Preview"
                sx={{height: '100%', width: "auto", borderRadius: "8px"}}
            />
        </Box>
    );
}